import * as React from "react";
import './FormUpgrade.css'
import {formStores} from "../../../state/mobx";
import FormButton from "../../../../../components/FormButton/FormButton";
import {observer} from "mobx-react";
import {InputTypes} from "../../../components/FormStepper/InputTypes";
import FormStepper from "../../../components/FormStepper/FormStepper";
import FormFinish from "../../SignUpForm/FormFinish/FormFinish";
import {UpgradeState} from "src/scenes/Forms/state/UpgradeState";
import {Redirect, RouteComponentProps} from "react-router-dom";
import {AnalyticsAccountEvents} from "../../../../../services/Analytics/AnalyticsAccountEvents";
import {MyAccountStores} from "../../../../MyAccount/state/mobx";
import NavigationConstants from "../../../../Navigation/NavigationConstants";
import MixPanelAnalyticsService from "../../../../../services/Analytics/MixPanelAnalyticsService";

interface IProps extends RouteComponentProps<any> {
    closeWindowNavigationPath : string;
}

interface ILocalState {
    inputValue: any;
    selectedOption: number;
    navigate : boolean;
}

const STORE = formStores.upgradeStore;
const accountStore = MyAccountStores.accountUserStore;
const storePropertyName = "upgrade";

@observer
export default class FormUpgrade  extends React.Component<
    IProps,
    ILocalState
    > {

    public state: ILocalState = {
        inputValue: '',
        selectedOption: 0,
        navigate : false
    };

    constructor (props: IProps) {
        super(props);
        if(!accountStore.selectedPlan) {
            props.history.replace(NavigationConstants.myAccount);
        }
        if(!STORE.formInput[storePropertyName]) {
            STORE.formInput[storePropertyName] = {};
        }
    }

    
    public next = () => {
        MixPanelAnalyticsService.track(AnalyticsAccountEvents.managePlanSubmit);
        STORE.updateScreen(UpgradeState.finish);
    };

    public hasAgreement = () => {
        this.setState({selectedOption: 1});
    };

    public noAgreement = () => {
        this.setState({selectedOption: 2});

    };

    public renderSteps = () => {
        switch (STORE.currentScreen) {
            case UpgradeState.verification: {
                const verificationSteps: any = [
                    {
                        isHeader: true,
                        title: "Manage plan",
                        subTitle: "Changing offices within the same location? Adjust your corresponding financing amount here." ,
                        inputType: InputTypes.none
                    },
                    {
                        title: "Upload your new lease. PDF format only",
                        inputType: InputTypes.file,
                        propName: "upgradePdfFile"
                    }
                ];

               return (<FormStepper steps={verificationSteps} store={STORE} navigationProperty={storePropertyName}/>);
            }
            case UpgradeState.finish: return <FormFinish {...this.props} store={STORE} isUpgrade={true}/>;
            default: return null
        }
    };

    public upgradePlan = () => {
        if(STORE.allowFinishForm) {
            STORE.upgradePlan()
        }
    };

    public closeWindow = () => {
        this.setState({navigate: true});
        STORE.initState();
    };

    public renderNavigation = () => {
        if (STORE.currentScreen === UpgradeState.verification) {
            const btnClasses = STORE.allowFinishForm? 'yellow' : 'disabled';
            return (<div className="coverage-navigation">
                <FormButton btnText={"Submit request"} classes={btnClasses} click={this.upgradePlan}/>
            </div>);
        }
        return null;
    }

    public renderSupportLink = () => {
        if(!STORE.formInput.pdfFile &&  STORE.currentScreen !== UpgradeState.finish) {
            return <div className="support-link">
                <span> For more information contact </span>
                <span className="mail-link"><a href = "mailto: support@salaryo.com"> support@salaryo.com</a></span>
            </div>
        }
        return null
    };

    public render() {
        const { navigate } = this.state;
        const { closeWindowNavigationPath } = this.props;

        if (navigate) {
            return <Redirect to={closeWindowNavigationPath} />;
        }

        return (
            <>
                <div className="upgrade-container">
                    {this.renderSteps()}
                    {this.renderSupportLink()}
                </div>
                {this.renderNavigation()}

            </>
        )}
}




// WEBPACK FOOTER //
// ./src/scenes/Forms/screens/FormUpgradePlan/FormUpgrade/FormUpgrade.tsx